import api from './api';

class ServicesService {
    /**
     * Get services for a vendor
     * @param {number} vendorId - Vendor ID
     * @param {Object} params - Query parameters (page, limit, status, etc.)
     * @returns {Promise} API response
     */
    async getServices(vendorId, params = {}) {
        try {
            const response = await api.get(`/vendors/${vendorId}/services`, { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get service details by ID
     * @param {number} serviceId - Service ID
     * @returns {Promise} API response
     */
    async getServiceDetail(serviceId) {
        try {
            const response = await api.get(`/services/${serviceId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Update service status
     * @param {number} serviceId - Service ID
     * @param {Object} statusData - Status update data
     * @returns {Promise} API response
     */
    async updateServiceStatus(serviceId, statusData) {
        try {
            const response = await api.put(`/services/${serviceId}/status`, statusData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Assign driver to service
     * @param {number} serviceId - Service ID
     * @param {number} driverId - Driver ID
     * @returns {Promise} API response
     */
    async assignDriver(serviceId, driverId) {
        try {
            const response = await api.put(`/services/${serviceId}/assign-driver`, {
                driver_id: driverId
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const servicesService = new ServicesService();
